import { render } from "./CharacterSummaryView.vue?vue&type=template&id=0e98d7a2&scoped=true&ts=true"
import script from "./CharacterSummaryView.vue?vue&type=script&lang=ts"
export * from "./CharacterSummaryView.vue?vue&type=script&lang=ts"

import "./CharacterSummaryView.vue?vue&type=style&index=0&id=0e98d7a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e98d7a2"]])

export default __exports__